import * as React from "react";
import PropTypes from 'prop-types';

const SvgErrorFill = props => {
  if (props.id !== "_svgerrorfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M20 28.584a2.139 2.139 0 112.14-2.138A2.14 2.14 0 0120 28.584zm-2.14-6.425h4.28V11.456h-4.28v10.703zm16.26-9.304l-7.07-6.996a2.821 2.821 0 00-2-.859l-10.13.03a2.759 2.759 0 00-1.92.82l-6.92 6.805A3.663 3.663 0 005 15.263v9.694c0 .794.317 1.557.88 2.118l7 6.996c.589.595 1.392.93 2.23.929h9.8a3.152 3.152 0 002.26-.94l6.74-6.755A3.779 3.779 0 0035 24.627v-9.604a3 3 0 00-.88-2.168z" /></svg>;
};

SvgErrorFill.displayName = "_svgerrorfill";
SvgErrorFill.propTypes = {
  id: PropTypes.string
};
SvgErrorFill.defaultProps = {
  id: ''
};
export default SvgErrorFill;